import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Admin from "./pages/Admin";
import UploadTemplate from "./pages/UploadTemplate";
import EditTemplate from "./pages/EditTemplate";
import { auth } from "./Firebase"; // Import Firebase auth

function App() {
  const [user, setUser] = useState(null);

  // Check if user is authenticated
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        // Set user with email and default role
        setUser({ role: "user", username: firebaseUser.email });
        // For demonstration, set specific users as admin
        if (firebaseUser.email === "admin@example.com") {
          setUser({ role: "admin", username: firebaseUser.email });
        }
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            user ? <Dashboard user={user} /> : <Login setUser={setUser} />
          }
        />
        <Route path="/dashboard" element={<Dashboard user={user} />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/signup" element={<Signup setUser={setUser} />} />
        <Route
          path="/admin-dashboard"
          element={
            user && user.role === "admin" ? (
              <Admin />
            ) : (
              <Login setUser={setUser} />
            )
          }
        />
        <Route
          path="/upload-template"
          element={user ? <UploadTemplate /> : <Login setUser={setUser} />}
        />
        <Route
          path="/edit-template/:templateId"
          element={user ? <EditTemplate /> : <Login setUser={setUser} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
